import { createApp } from "vue";
import { createWebHistory, createRouter } from "vue-router";

// styles

import "@fortawesome/fontawesome-free/css/all.min.css";
import "@/assets/styles/tailwind.css";

// mouting point for the whole app

import App from "@/App.vue";

// views without layouts

import Landing from "@/views/Landing.vue";
import DVCommand from "@/views/DVCommand.vue";
import WaveCommand7 from "@/views/WaveCommand7.vue";
import WaveData from "@/views/WaveData.vue";
import WaveEdge from "@/views/WaveEdge.vue";
import PumpLink7 from "@/views/PumpLink7.vue";
import BlenderLink7 from "@/views/BlenderLink7.vue";
import DatavanMPC from "@/views/DatavanMPC.vue";
import About from "@/views/About.vue";
import FracSupport from "./views/FracSupport.vue";
import NotFound from "@/views/NotFound.vue";

// routes

const routes = [
   {
      path: "/dvcommand",
      component: DVCommand,
   },
   {
      path: "/wavecommand7",
      component: WaveCommand7,
   },
   {
      path: "/wavedata",
      component: WaveData,
   },
   {
      path: "/waveedge",
      component: WaveEdge,
   },
   {
      path: "/pumplink7",
      component: PumpLink7,
   },
   {
      path: "/blenderlink7",
      component: BlenderLink7,
   },
   {
      path: "/mpc",
      component: DatavanMPC,
   },
   {
      path: "/about",
      component: About,
   },
   {
      path: "/fracsupport",
      name: "FracSupport",
      component: FracSupport,
   },
   {
      path: "/",
      component: Landing,
   },
   { path: "/:pathMatch(.*)*", component: NotFound },
];

const router = createRouter({
   history: createWebHistory(process.env.BASE_URL),
   routes,
   // Always land at top of the destination page (prevents odd mid-page flashes)
   scrollBehavior(to, from, savedPosition) {
      if (to.hash) {
         return { el: to.hash, behavior: "smooth" };
      }
      if (savedPosition) {
         return savedPosition;
      }
      return { top: 0 };
   },
});

createApp(App).use(router).mount("#app");